import { render, staticRenderFns } from "./contactFilters.vue?vue&type=template&id=52239af9&"
import script from "./contactFilters.vue?vue&type=script&lang=ts&"
export * from "./contactFilters.vue?vue&type=script&lang=ts&"
import style0 from "./contactFilters.vue?vue&type=style&index=0&id=52239af9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports